// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KQ9xW5XVy4u9onoy {
	max-width: 1310px;
	margin: 0 auto;
	padding-bottom: 96px;
}

.tl2xKnfOSvw3_wes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -1.5rem;
}

.SnvnngL07L8EHDGG {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Hpj6RMpqOUUzdI5e {
	margin-bottom: -1.5rem;
	margin-top: 3rem;
	border: 1px solid #C6D4E1;
}

.tl2xKnfOSvw3_wes h2{
	font-size: 30px;
	font-weight: 700;
}

.jpj3IZb8YIQThTYO {
	background-color: #4D87BE;
	font-size: 16px;
	font-weight: 500;
	font-family: Roboto;
	border-radius: 10px;
	max-height: 35px;
}

.vhrWMKZYm4kv64lg {
	width: 360px;
	height: 58px;
	border-radius: 16px;
	background: #FFFFFF;
	box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.vhrWMKZYm4kv64lg .p-dropdown-label {
	display: flex;
	align-items: center;
	justify-content: left;
	padding-left: 20px;
}

.jWUmQY_rViMzqmKa {
	width: 360px;
	height: 58px;
	border-radius: 16px !important;
	background: #FFFFFF;
	box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.jWUmQY_rViMzqmKa input {
	border-radius: 16px !important;
	padding-left: 20px;
}

@media screen and (max-width: 1665px) {
	.SnvnngL07L8EHDGG {
		flex-direction: column;
		gap: 8px;
	}
	
	.Hpj6RMpqOUUzdI5e {
		width: 100%;
	}
}

@media screen and (max-width: 768px) {
	.SnvnngL07L8EHDGG {
		flex-direction: column;
		gap: 8px;
	}
	
	.vhrWMKZYm4kv64lg {
		height: 44px;
	}
	
	.jWUmQY_rViMzqmKa {
		height: 44px;
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Statistics.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,gDAAgD;AACjD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,8BAA8B;CAC9B,mBAAmB;CACnB,gDAAgD;AACjD;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC;EACC,sBAAsB;EACtB,QAAQ;CACT;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,QAAQ;CACT;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,YAAY;CACb;AACD","sourcesContent":[".pageWrapper {\r\n\tmax-width: 1310px;\r\n\tmargin: 0 auto;\r\n\tpadding-bottom: 96px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: -1.5rem;\r\n}\r\n\r\n.block {\r\n  margin-top: 3rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.divider {\r\n\tmargin-bottom: -1.5rem;\r\n\tmargin-top: 3rem;\r\n\tborder: 1px solid #C6D4E1;\r\n}\r\n\r\n.header h2{\r\n\tfont-size: 30px;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.downloadBtn {\r\n\tbackground-color: #4D87BE;\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tfont-family: Roboto;\r\n\tborder-radius: 10px;\r\n\tmax-height: 35px;\r\n}\r\n\r\n.dropdown {\r\n\twidth: 360px;\r\n\theight: 58px;\r\n\tborder-radius: 16px;\r\n\tbackground: #FFFFFF;\r\n\tbox-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.dropdown :global(.p-dropdown-label) {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: left;\r\n\tpadding-left: 20px;\r\n}\r\n\r\n.datepicker {\r\n\twidth: 360px;\r\n\theight: 58px;\r\n\tborder-radius: 16px !important;\r\n\tbackground: #FFFFFF;\r\n\tbox-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.datepicker input {\r\n\tborder-radius: 16px !important;\r\n\tpadding-left: 20px;\r\n}\r\n\r\n@media screen and (max-width: 1665px) {\r\n\t.block {\r\n\t\tflex-direction: column;\r\n\t\tgap: 8px;\r\n\t}\r\n\t\r\n\t.divider {\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n\t.block {\r\n\t\tflex-direction: column;\r\n\t\tgap: 8px;\r\n\t}\r\n\t\r\n\t.dropdown {\r\n\t\theight: 44px;\r\n\t}\r\n\t\r\n\t.datepicker {\r\n\t\theight: 44px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `KQ9xW5XVy4u9onoy`;
export var header = `tl2xKnfOSvw3_wes`;
export var block = `SnvnngL07L8EHDGG`;
export var divider = `Hpj6RMpqOUUzdI5e`;
export var downloadBtn = `jpj3IZb8YIQThTYO`;
export var dropdown = `vhrWMKZYm4kv64lg`;
export var datepicker = `jWUmQY_rViMzqmKa`;
export default ___CSS_LOADER_EXPORT___;
